import {
    apiRequest,
    komponenPenilaianList,
    komponenPenilaianActive,
    komponenPenilaianInactive,
} from "../../../../../../services/adapters/master/komponenPenilaianService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", komponenPenilaianList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", komponenPenilaianInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", komponenPenilaianActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository